export const Custom_jacket = 'https://jacket-ecomm.vercel.app/'
// export const baseURL = 'http://localhost:8080'
export const baseURL = 'https://api.easyjackets.com'